import { render, staticRenderFns } from "./road-defects.vue?vue&type=template&id=38455fe0&scoped=true&"
import script from "./road-defects.vue?vue&type=script&lang=ts&"
export * from "./road-defects.vue?vue&type=script&lang=ts&"
import style0 from "./road-defects.vue?vue&type=style&index=0&id=38455fe0&prod&lang=scss&scoped=true&"
import style1 from "./road-defects.vue?vue&type=style&index=1&id=38455fe0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38455fe0",
  null
  
)

export default component.exports